// Library
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// Components
import PrivateRoutes from "./PrivateRoutes";
import Admin from "../layouts/Teacher";
import Auth from "../layouts/Auth";
import Parent from "../layouts/Parent";
import Principal from "../layouts/Principal";
import EducationOfficer from "../layouts/EducationOfficer";
import DistrictOfficer from "../layouts/DistrictOfficer";
import StateOfficer from "../layouts/StateOfficer";

// services
import { getUserRole, isLoggedIn } from "../Services/UserAuth/UserAuthenticate";

// routes
import { Routes } from "../routes";
import PageNotFound from "../Pages/PageNotFound/PageNotFound";
import SuperAdmin from "../layouts/SuperAdmin";

export default function RootRoutes() {
  return (
    <>
      {!getUserRole() && !isLoggedIn() ? (
        <Switch>
          <Route path="/auth" render={(props) => <Auth {...props} />} />
          <Redirect from="/" to="/auth/login" />
        </Switch>
      ) : getUserRole() === "3" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/teacher" component={Admin} />
          <Redirect from="/" to="/teacher/index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "4" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/parent" component={Parent} />
          <Redirect from="/" to="/parent/parent-index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "5" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/principal" component={Principal} />
          <Redirect from="/" to="/principal/stateOfficer-index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "6" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/blockOfficer" component={EducationOfficer} />
          <Redirect from="/" to="/blockOfficer/stateOfficer-index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "7" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/districtOfficer" component={DistrictOfficer} />
          <Redirect from="/" to="/districtOfficer/stateOfficer-index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "9" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/stateOfficer" component={StateOfficer} />
          <Redirect from="/" to="/stateOfficer/stateOfficer-index" />
          <Route component={PageNotFound} />
        </Switch>
      ) : getUserRole() === "1" && isLoggedIn() ? (
        <Switch>
          <PrivateRoutes path="/super-admin" component={SuperAdmin} />
          <Redirect from="/" to="/super-admin/grievance" />
          <Route component={PageNotFound} />
        </Switch>
      ) : (
        <></>
      )}
    </>
  );
}
